import { IApiResponse } from "../../../@types/api-response.type";
import { Api } from "../ApiConfig"
import { ApiException } from "../ApiException"
import { getErrorMessage } from "../../../utils/utils";
import { ICustomField } from "../../../@types/customField.type";

export const getAllProjectsCustomField = async () => {

  try {
    const { data } = await Api.get(`/api/ProjectCustomField/GetAllProjectCustomField`)
    return data

  } catch (error) {
    throw new ApiException(getErrorMessage(error, 'Erro ao buscar os Campos'))
  }
}


export const getProjectCustomFieldById = async (id: string): Promise<IApiResponse<ICustomField> | ApiException> => {

  try {
    const { data } = await Api.get<IApiResponse<ICustomField>>(`/api/ProjectCustomField/GetProjectCustomFieldById?id=${id}`)
    return data

  } catch (error) {
    throw new ApiException(getErrorMessage(error, 'Erro ao buscar o campo'))
  }
}


export const addOrUpdateProjectCustomField = async (projectCustomField: ICustomField) => {
  try {
  const { data } =  await Api.post('/api/ProjectCustomField/AddOrUpdateProjectCustomField', projectCustomField);
  return data 

  } catch (error) {
    const message = 'Erro ao criar ou atualizar campo do Projeto';
    throw new ApiException(getErrorMessage(error, message));
  }
}


export const deleteProjectCustomField = async (id: string) => {

  try {
    await Api.delete(`/api/ProjectCustomField/DeleteProjectCustomField/${id}`);
  } catch (error) {
    throw new ApiException(getErrorMessage(error, 'Erro ao deletar o campo'))
  }
}
